.single-option-filter-list {
  --se-list-item-selected-background: none;
}

.single-option-item-label {
  font-size: 14px;
  line-height: 20px;
}
